import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ReactCrop from 'react-image-crop'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import lang from 'lang'
import Loader from '../loader/loader'
import { cropImage } from '../../../_helpers/cropImage'
import { OCRService } from '../../services/ocr'
import centerAspectCrop from '@/utils/centerAspectCrop'

import { toast } from '@/modules/base/components/toast/toastConfig'

export const OcrImageViewer = (props) => {
  const { src, onOcrResult, imageStyle, customClasses } = props
  const styles = useStyles(props)
  const classes = { ...styles, ...customClasses }

  const [img, setImg] = useState()
  const [crop, setCrop] = useState()
  const [isLoading, setLoading] = useState(false)

  const handleCropChange = (crop) => {
    setCrop(crop)
  }
  const handleCropped = (crop) => {
    if (!img || !crop.width || !crop.height) return

    setLoading(true)
    cropImage(img, crop)
      .then((blob) => OCRService.analyze(blob))
      .then((data) => {
        const { text } = data
        onOcrResult && onOcrResult(text)
      })
      .catch(() => toast.showToast({ type: 'error', message: lang.ocrImageViewerErrorMessage }))
      .finally(() => setLoading(false))
  }
  const handleImageLoaded = (e) => {
    const { width, height } = e.currentTarget
    setImg(e.currentTarget)
    setCrop(centerAspectCrop(width, height))
  }

  return (
    <>
      <div className={classes.root}>
        <ReactCrop
          ruleOfThirds
          crop={crop}
          crossorigin='anonymous'
          imageStyle={imageStyle}
          className={clsx(classes.image, classes.cropSelection)}
          onComplete={handleCropped}
          onChange={handleCropChange}>
          <img src={src} onLoad={handleImageLoaded} />
        </ReactCrop>
        <Loader visible={isLoading} text={lang.ocrImageViewerLoaderText} customClass={classes.loader} />
      </div>
    </>
  )
}

OcrImageViewer.props = {
  receipt: PropTypes.object.isRequired,
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    position: 'relative',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  image: {
    display: 'flex',
    objectFit: 'contain',
    minHeight: 'calc(90vh - 85px)',
  },
  cropSelection: {
    '& .ReactCrop__crop-mask > rect': {
      fill: 'rgba(0,0,0,0.25)',
    },
  },
  loader: (props) => ({
    background: 'rgba(255, 255, 255, 0.8)',
    height: `calc(100vh - ${theme.pageContentOffset}px)`,
    width: props.imageStyle ? props.imageStyle.width : '100%',
  }),
}))

export default OcrImageViewer
